import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  DownloadBusinessUserCSVResponse,
  DownloadBusinessUserCSVPayload,
} from "models/userListBusiness/downloadBusinessUserCSV";
import { httpStatus } from "configs/httpStatus";
import { downloadBusinessUserCSV } from "services/userListBusiness";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./downloadBusinessUserCSVActions";

function* downloadBusinessUserCSVSaga() {
  try {
    const response: DownloadBusinessUserCSVResponse = yield call(
      downloadBusinessUserCSV
    );
    if (
      response.status === httpStatus.StatusOK ||
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusUnprocessableEntity
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadBusinessUserCSVWatcher() {
  yield takeLatest(
    ActionType.DOWNLOAD_BUSINESS_USER_CSV as any,
    downloadBusinessUserCSVSaga
  );
}

export default [fork(onDownloadBusinessUserCSVWatcher)];
